/*!

=========================================================
* Argon Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

class Calendar extends React.Component {
  render() {
    return (
      <>
        <Container fluid>
          <footer className="footer pt-0">
            <Row className="align-items-center justify-content-lg-between">
              <Col lg="6">
                <div className="copyright text-center text-lg-left text-muted">
                  © {new Date().getFullYear()} Fitness Industry Supplier Association
                </div>
              </Col>
              <Col lg="6">
                <Nav className="nav-footer justify-content-center justify-content-lg-end">
                  <NavItem>
                    <NavLink to="/" tag={Link}>Home</NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/auth/supplierform" tag={Link}>
                      Host Supplier Registration
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/auth/buyerform" tag={Link}>
                      VIP Guest Registration
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/auth/login" tag={Link} className="text-dark">
                      Admin Login
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink href="https://www.example.com" target="_blank">
                      License
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </footer>
        </Container>
      </>
    );
  }
}

export default Calendar;
